module.exports = __webpack_public_path__ + "035b6158c846257bdf5d8a3a1af87c44.png";